module.exports = __webpack_public_path__ + "static/Webnyay Rules of Dispute Resolution 2020-e2f951af279426526784747147d84b46.pdf";